import { useTranslation } from 'react-i18next';

import { SALARY_SCALES } from 'RestAPIs/endpoints';
import { useDeleteById } from 'RestAPIs/useDeleteById';

import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

import CreateEditSalaryScalesForm from './components/form/CreateEditSalaryScalesForm';

import { useGetColumnDefs } from './hooks/useGetColumnDefs';
import { useGetTableData } from './hooks/useGetTableData';

const SalaryScales = () => {
  const { t } = useTranslation('common');
  const { data, isFetching } = useGetTableData();
  const columns = useGetColumnDefs();
  const { mutate: deleteSalaryScale } = useDeleteById(SALARY_SCALES, [
    'salaryScales',
    'list'
  ]);

  const onDeleteClick = (id) => {
    deleteSalaryScale(id);
  };

  return (
    <TableCRUDLayout
      FormComponent={CreateEditSalaryScalesForm}
      rows={data}
      loading={isFetching}
      columns={columns}
      getRowId={(row) => row.salaryId}
      onDeleteClick={onDeleteClick}
      confirmationTitle={t('salaryScales.confirmationTitle')}
      confirmationBody={t('salaryScales.confirmationBody')}
      customCreateTitle={t('salaryScales.createTitle')}
      customEditTitle={t('salaryScales.editTitle')}
    />
  );
};
export default SalaryScales;
